module.exports = __webpack_public_path__ + "img/blender.8376db71.svg";